module.exports = __webpack_public_path__ + "img/berlin-lg.8e4704a5.jpg";